(function () {
  if (window.__packDiscountNoticeInit) return;
  window.__packDiscountNoticeInit = true;

  function getProductInfoRoot(el) {
    return el.closest('product-info') || document;
  }

  function getSelectedPackInput(root) {
    return (
      root.querySelector('.pack-selector input[type="radio"][name="pack"]:checked') ||
      root.querySelector('pack-product-form input[type="radio"][name="pack"]:checked') ||
      root.querySelector('input[type="radio"][name="pack"]:checked')
    );
  }

  function getQuantityOptionIndex(root) {
    const desktopChecked = root.querySelector('[data-pack-desktop-picker] input[type="radio"]:checked');
    if (desktopChecked) {
      const fieldset = desktopChecked.closest('[data-pack-desktop-picker]');
      const radios = fieldset ? Array.from(fieldset.querySelectorAll('input[type="radio"]')) : [];
      return radios.indexOf(desktopChecked);
    }

    const mobileSelect = root.querySelector('[data-pack-mobile-option-select]');
    if (mobileSelect && mobileSelect.options.length) {
      return mobileSelect.selectedIndex;
    }

    return -1;
  }

  function getSelectedPackQuantity(root) {
    const input = getSelectedPackInput(root);
    if (input) {
      const qty = parseInt(input.dataset.packQuantity || input.getAttribute('data-pack-quantity') || '1', 10);
      return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }

    const qtyIndex = getQuantityOptionIndex(root);
    if (qtyIndex >= 0) return qtyIndex + 1;

    return 1;
  }

  function isSinglePackSelection(root) {
    const input = getSelectedPackInput(root);
    if (input) {
      const key = (input.value || input.dataset.packKey || '').toLowerCase();
      const qty = getSelectedPackQuantity(root);
      return qty <= 1 || key === 'single';
    }

    return getQuantityOptionIndex(root) <= 0;
  }

  function isMultiPackSelected(root) {
    return !isSinglePackSelection(root);
  }

  function isSubscriptionSelected(root) {
    const subscription = root.querySelector('[name="purchase_option"][value="subscription"]');
    return !!(subscription && subscription.checked);
  }

  function parsePercent(text) {
    if (!text) return '';
    const match = String(text).match(/(\d+(?:\.\d+)?)\s*%/);
    return match ? Math.round(parseFloat(match[1])) + '%' : '';
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    const num = parseFloat(String(text).replace(/[^0-9.]/g, ''));
    if (!Number.isFinite(num)) return null;
    return Math.round(num * 100);
  }

  function getSelectedVariant(root) {
    const scripts = root.querySelectorAll('script[data-selected-variant]');
    for (let i = scripts.length - 1; i >= 0; i--) {
      try {
        const variant = JSON.parse(scripts[i].textContent || 'null');
        if (variant && variant.id) return variant;
      } catch (e) {}
    }
    return null;
  }

  function getUnitPriceCents(root) {
    const variant = getSelectedVariant(root);
    if (variant && typeof variant.price === 'number') return variant.price;

    const packForm = root.querySelector('pack-product-form');
    const firstVariant =
      packForm && packForm.currentProduct && packForm.currentProduct.variants && packForm.currentProduct.variants[0];
    if (firstVariant && typeof firstVariant.price === 'number') return firstVariant.price;

    const select = root.querySelector('select[data-pack-key]');
    if (select && select.options.length) {
      const opt = select.options[select.selectedIndex];
      const price = parseInt(opt && opt.dataset ? opt.dataset.variantPrice || '' : '', 10);
      if (Number.isFinite(price)) return price;
    }

    return null;
  }

  function discountFromCompareAt(price, compareAt) {
    if (!compareAt || !price || compareAt <= price) return '';
    return Math.round(((compareAt - price) / compareAt) * 100) + '%';
  }

  function isStaticMultiPackUi(root) {
    return !!root.querySelector('.pack-selector[data-multi-pack="true"]');
  }

  function isProductPacksMetafieldUi(root) {
    const info =
      root.tagName === 'PRODUCT-INFO' ? root : root.querySelector('product-info') || root.closest('product-info');
    return !!(info && info.dataset.bundlePack === 'true');
  }

  function isQuantityOptionPackUi(root) {
    return getQuantityOptionIndex(root) >= 0;
  }

  function getProductFromRoot(root) {
    const sellingPlanForm = root.querySelector('selling-plan-form');
    if (sellingPlanForm && sellingPlanForm.currentProduct) {
      return sellingPlanForm.currentProduct;
    }
    return null;
  }

  function getQuantityOptionPosition(product) {
    if (!product || !product.options) return -1;
    for (let i = 0; i < product.options.length; i++) {
      const name = String(product.options[i] || '').toLowerCase();
      if (name === 'quantity' || name === 'qty' || name.includes('bundle')) {
        return i;
      }
    }
    return -1;
  }

  function getQuantityOptionDiscountFromVariants(root) {
    const product = getProductFromRoot(root);
    const variant = getSelectedVariant(root);
    const qtyIndex = getQuantityOptionIndex(root);
    if (!product || !variant || qtyIndex <= 0) return '';

    const optionIndex = getQuantityOptionPosition(product);
    if (optionIndex < 0) return '';

    const optionKey = 'option' + (optionIndex + 1);
    const singleValue = product.options[optionIndex];
    if (!singleValue) return '';

    const singleVariant = product.variants.find(function (candidate) {
      if (candidate[optionKey] !== singleValue) return false;
      for (let i = 1; i <= 3; i++) {
        if (i === optionIndex + 1) continue;
        const currentValue = variant['option' + i];
        if (currentValue && candidate['option' + i] !== currentValue) return false;
      }
      return true;
    });

    if (!singleVariant || typeof singleVariant.price !== 'number') return '';

    const qty = qtyIndex + 1;
    const fullCents = singleVariant.price * qty;
    if (fullCents > variant.price) {
      return Math.round(((fullCents - variant.price) / fullCents) * 100) + '%';
    }

    return '';
  }

  function getPackDiscountPercent(root) {
    const input = getSelectedPackInput(root);
    const qty = getSelectedPackQuantity(root);

    if (!isMultiPackSelected(root)) return '';

    if (input) {
      const packEl =
        input.closest('[data-pack-discount]') ||
        input.closest('.pack-option') ||
        input.closest('.pack-select-dropdown__option');

      if (packEl && packEl.dataset.packDiscount) {
        const fromData = parsePercent(packEl.dataset.packDiscount);
        if (fromData) return fromData;
      }

      const badge = packEl && packEl.querySelector('.pack-badge');
      if (badge && badge.textContent.trim()) {
        const fromBadge = parsePercent(badge.textContent);
        if (fromBadge) return fromBadge;
      }
    }

    // Static multi_packs: volume discount comes from data-pack-volume-discount-* on the picker.
    if (isStaticMultiPackUi(root)) {
      const qty = getSelectedPackQuantity(root);
      if (window.ambrosiaPackVolumeDiscount) {
        const pct = window.ambrosiaPackVolumeDiscount.getPercent(qty, root);
        if (pct > 0) return Math.round(pct) + '%';
      }
      return '';
    }

    if (isProductPacksMetafieldUi(root)) {
      const qty = getSelectedPackQuantity(root);
      if (window.ambrosiaPackVolumeDiscount) {
        const pct = window.ambrosiaPackVolumeDiscount.getPercent(qty, root);
        if (pct > 0) return Math.round(pct) + '%';
      }
      return '';
    }

    const fromQuantityVariants = getQuantityOptionDiscountFromVariants(root);
    if (fromQuantityVariants) return fromQuantityVariants;

    const variant = getSelectedVariant(root);
    if (variant && isQuantityOptionPackUi(root)) {
      const fromVariant = discountFromCompareAt(variant.price, variant.compare_at_price);
      if (fromVariant) return fromVariant;
    }

    const otEl = root.querySelector('[data-option="onetime"] [data-pack-price]');
    const otCents = parseMoneyToCents(otEl && otEl.textContent);
    const unitCents = getUnitPriceCents(root);

    if (otCents && unitCents && qty > 1 && isQuantityOptionPackUi(root)) {
      const fullCents = unitCents * qty;
      if (fullCents > otCents) {
        return Math.round(((fullCents - otCents) / fullCents) * 100) + '%';
      }
    }

    return '';
  }

  function updateNotice(noticeEl) {
    const root = getProductInfoRoot(noticeEl);
    const packDiscount = getPackDiscountPercent(root);

    if (!isSubscriptionSelected(root) || !isMultiPackSelected(root) || !packDiscount) {
      noticeEl.classList.remove('is-visible');
      return;
    }

    noticeEl.querySelector('.pack-discount-notice__text').innerHTML =
      'Subscribe discount + <strong>' + packDiscount + '</strong> cart volume discount are both applied';
    noticeEl.classList.add('is-visible');
  }

  function updateAll(scope) {
    const root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('[data-pack-discount-notice]').forEach(updateNotice);
  }

  function bind(root) {
    if (!root || root.dataset.packDiscountNoticeBound === 'true') return;
    root.dataset.packDiscountNoticeBound = 'true';

    root.addEventListener('change', function (event) {
      const target = event.target;
      if (!target) return;
      if (
        target.matches('[name="pack"]') ||
        target.matches('[name="purchase_option"]') ||
        target.matches('select[name="selling_plan"]') ||
        target.matches('[data-pack-mobile-option-select]') ||
        target.closest('[data-pack-desktop-picker]')
      ) {
        updateAll(root);
      }
    });

    root.addEventListener('click', function (event) {
      if (event.target.closest('.pack-select-dropdown__option')) {
        window.setTimeout(function () {
          updateAll(root);
        }, 0);
      }
    });
  }

  function init(scope) {
    const roots = [];
    if (scope && scope.tagName === 'PRODUCT-INFO') {
      roots.push(scope);
    } else if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('product-info').forEach(function (el) {
        roots.push(el);
      });
    } else {
      document.querySelectorAll('product-info').forEach(function (el) {
        roots.push(el);
      });
    }

    if (!roots.length && document.querySelector('[data-pack-discount-notice]')) {
      roots.push(document);
    }

    roots.forEach(function (root) {
      bind(root);
      updateAll(root);
    });

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      if (!window.__packDiscountNoticeVariantSubscribed) {
        window.__packDiscountNoticeVariantSubscribed = true;
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          updateAll(document);
        });
      }
    }
  }

  window.ambrosiaPackDiscountNotice = { init: init, update: updateAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
